.ge{border:1px solid #ddd;}